/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const PLATFORM_OWNER_CAN_ABILITY = [
  ['read', 'MyProfile'],
  ['read', 'MasterAdminInvite'],
  ['read', 'ForgotPassword'],
  ['read', 'InviteAccepted'],
  ['read', 'InviteRejected'],
  ['read', 'InviteStatus'],
  ['read', 'InviteExpired'],
];

export const PLATFORM_OWNER_CANNOT_ABILITY = [
  ['read', 'OrganizationProfile'],
  ['read', 'Application'],
  ['read', 'DraftAppList'],
  ['read', 'ApplicationStatus'],
  ['read', 'SubmittedAppList'],
  ['read', 'RejectedAppList'],

  ['read', 'OrgAdminList'],
  ['read', 'EmployeeList'],
  ['read', 'PaymentHistory'],
];
